import React from 'react'
import { PropTypes } from 'prop-types'
const PedestrianIcon = (props) => (
  <svg
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13.33 22"
    fill={props.fill ? props.fill : '#262626;'}
    width={props.width ? props.width : '30'}
    height={props.height ? props.height : '30'}
  >
    <g id="Layer_1-2">
      <path
        className="cls-1"
        d="m1.18,22l2.97-14.99-2.58,1.1v3.4H0v-4.43l4.91-2.07c.24-.1.49-.17.75-.19s.52-.01.78.04c.29.05.54.14.75.28.21.14.39.31.52.51l1.07,1.69c.53.82,1.19,1.46,1.98,1.93.79.47,1.64.7,2.55.7v1.53c-1.19-.03-2.25-.29-3.16-.78s-1.74-1.23-2.47-2.24l-.97,3.89,2.35,2.12v7.5h-1.53v-6.14l-2.76-2.51-2.02,8.65h-1.59ZM7.88,3.73c-.51,0-.95-.18-1.32-.55s-.55-.81-.55-1.32.18-.95.55-1.32.81-.55,1.32-.55.95.18,1.32.55.55.81.55,1.32-.18.95-.55,1.32-.81.55-1.32.55Z"
      />
    </g>
  </svg>
)

export default PedestrianIcon

PedestrianIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
}
